<script setup lang="ts">
import { removeEmojis } from '~/shared/utils/removeEmojis'

const {
  public: { BASE_URL },
} = useRuntimeConfig()
const { slug } = useRoute().params
const { getPostsCategories }
= useTabFilters()

const tags = await getPostsCategories()
const story = await useStoryblok(
  slug && slug.length > 0 && slug !== '/' ? slug.join('/') : 'blog',
  { version: useRoute().query._storyblok ? 'draft' : 'published' },
)

const currentTag = tags.find(tag => tag.value === story.value?.content.tag)
const seoData = ref(story.value?.content)
const component = resolveComponent(story.value?.content.component)

useSchemaOrg([
  defineBreadcrumb({
    itemListElement: [
      {
        position: 1,
        name: 'Главная',
        item: BASE_URL,
      },
      {
        position: 2,
        name: 'Блог',
        item: `${BASE_URL}blog`,
      },
      {
        position: 3,
        name: removeEmojis(currentTag.name),
        item: `${BASE_URL}blog?tag=${story.value?.content.tag}`,
      },
      {
        position: 4,
        name: seoData.value?.title,
      },
    ],
  }),
  defineArticle({
    '@type': 'BlogPosting',
    'name': seoData.value?.title,
    'description': seoData.value?.description,
    'image': seoData.value?.article_img?.filename,
    'datePublished': story.value?.first_published_at,
    'dateModified': story.value?.published_at,
  }),
])

useServerSeoMeta({
  title: () => seoData.value?.title,
  ogTitle: () => seoData.value?.title,
  description: () => seoData.value?.description,
  ogDescription: () => seoData.value?.description,
  creator: () => seoData.value?.author,
  twitterCard: 'summary_large_image',
  ogType: 'website',
  ogLocale: 'ru-RU',
})

useHead({
  title: seoData.value?.title,
  meta: [
    { name: 'description', content: seoData.value?.description },
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
    { name: 'mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-title', content: seoData.value?.title },
  ],
})

</script>

<template>
  <component :is="component" v-if="story" :blok="story.content" :tag="currentTag" />
</template>
